exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Badge___3Nnpi {\n  cursor: help;\n}\n", ""]);

// exports
exports.locals = {
	"Badge": "Badge___3Nnpi"
};